import { useEffect, useRef } from 'react'

export default function useInterval(callback: () => unknown, delay: number | null, runOnInit?: boolean) {
    const savedCallback = useRef<() => unknown>()

    useEffect(() => {
        savedCallback.current = callback
    })

    useEffect(() => {
        function tick() {
            if (typeof savedCallback.current === 'function') {
                savedCallback.current()
            }
        }

        if (runOnInit) tick()

        if (delay !== null) {
            const id = setInterval(tick, delay)
            return () => {
                clearInterval(id)
            }
        }
    }, [delay, runOnInit])
}
